import {Service} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'

/**
 * @implements Service
 */
export default class GetCurrentUserService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   */
  constructor({repository}) {
    super({repository})

    this._repository = repository
  }

  static create({config}) {
    return new GetCurrentUserService({
      repository: UserRepositoriesFactory.cookieUserRepository({config})
    })
  }

  /**
   * @return {Promise<Object, Error>} returns current logged user
   * @property {Object} user
   */
  execute() {
    return this._repository.getCurrentUser()
  }
}
